import React from "react";
import { LegacyCard, TextField, InlineGrid, Button, Spinner } from "@shopify/polaris";

const JacketMeasurements = ({ values, errors, onChange, message, loading, onSave }) => {
  const fields = [
    { label: "Chest", key: "chest" },
    { label: "Stomach", key: "stomach" },
    { label: "Shoulder", key: "shoulder" },
    { label: "Sleeve (L)", key: "sleeveL" },
    { label: "Sleeve (R)", key: "sleeveR" },
    { label: "Jacket Length", key: "jacketLength" },
    { label: "1st Button Placement", key: "firstButtonPlacement" },
  ];

  return (
    <LegacyCard title="Jacket Measurements" sectioned>
      <InlineGrid columns={{ xs: 2, sm: 2, md: 2, lg: 3 }} gap="400">
        {fields.map(({ label, key }) => (
          <TextField
            key={key}
            label={label}
            value={values[key]}
            onChange={(value) => onChange(key)(value)}
            error={errors?.[key]}
          />

        ))}
      </InlineGrid>
      {message && (
        <p className="sucess_mess order_customer_mess">{message}</p>
      )}
      {onSave && (
        <div className="customerAddBtn order_cus_btn">
          {!loading ? (
            <Button variant="primary" onClick={onSave}>
              Save
            </Button>
          ) : (
            <Spinner accessibilityLabel="Saving measurements" size="small" />
          )}
        </div>
      )}
    </LegacyCard>
  );
};

export default JacketMeasurements;
